import type { SVGProps } from "react";
const SvgBarsCustom = (props: SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="currentColor"
        viewBox="0 0 448 512"
        {...props}
    >
        <rect
            width={448}
            height={60}
            y={68}
            data-position="top"
            data-role="line"
            rx={32}
        />
        <rect
            width={448}
            height={60}
            y={228}
            data-position="middle"
            data-role="line"
            rx={32}
        />
        <rect
            width={448}
            height={60}
            y={388}
            data-position="bottom"
            data-role="line"
            rx={32}
        />
    </svg>
);
export default SvgBarsCustom;
